var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hero-banner',{staticClass:"hero-banner-section-module",attrs:{"desktop-image":_vm.desktopImage,"mobile-image":_vm.mobileImage,"title":_vm.attributes.heroBannerSection_title,"to":_vm.toValue,"href":_vm.attributes.link_external}})}
var staticRenderFns = []

export { render, staticRenderFns }